import { allThemes, BoxProps, TextProps } from '@jfs/ui-new'

export const styles = {
  resendContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,

  resendTouchable: {
    alignSelf: 'center',
  } as BoxProps,

  countStyle: {
    fontSize: 12,
    fontWeight: 'FONT_WEIGHT_LIGHT',
    width: 16,
    marginStart: 4,
    color: allThemes.light.colors.PRIMARY_GREY,
  } as TextProps,

  secondStyle: {
    fontSize: 12,
    fontWeight: 'FONT_WEIGHT_LIGHT',
    color: allThemes.light.colors.PRIMARY_GREY,
  } as TextProps,
}
